import { render, staticRenderFns } from "./Betslip.vue?vue&type=template&id=0051728a"
import script from "./Betslip.vue?vue&type=script&lang=js"
export * from "./Betslip.vue?vue&type=script&lang=js"
import style0 from "./Betslip.vue?vue&type=style&index=0&id=0051728a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports